"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var clsx_1 = __importDefault(require("clsx"));
var reducers_1 = require("../../reducers");
require("./LanguageSelector.scss");
var action_1 = require("./redux/action");
var mapDispatchToProps = {
    changeLang: action_1.changeLanguage,
};
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps, mapDispatchToProps);
var LanguageSelector = function (props) {
    var currentLang = props.currentLang, className = props.className, changeLang = props.changeLang;
    var init = function () {
        if (currentLang.lang === '') {
            i18next_1.default.loadLanguages(['en', 'ar']);
            changeLang(i18next_1.default.language);
        }
    };
    init();
    return (react_1.default.createElement("div", { className: clsx_1.default('eta-languageSelector', className) },
        react_1.default.createElement(react_2.ActionButton, { onClick: function () { return changeLang('en'); }, checked: currentLang.lang === 'en' }, "EN"),
        react_1.default.createElement("h1", null, "|"),
        react_1.default.createElement(react_2.ActionButton, { onClick: function () { return changeLang('ar'); }, checked: currentLang.lang === 'ar' }, "\u0639\u0631\u0628\u0649")));
};
exports.default = connector(LanguageSelector);
//# sourceMappingURL=LanguageSelector.js.map